"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allocateProportionally = allocateProportionally;
const errors_1 = require("../errors");
const cents_1 = require("./cents");
// Méthode du plus fort reste : parts entières au sol, puis les centimes
// restants vont aux plus forts restes fractionnaires (indice bas en cas
// d'égalité). Somme exacte garantie — c'est la primitive qui interdit toute
// « correction du dernier taux » (R3).
function allocateProportionally(total, weights) {
    (0, cents_1.assertCents)(total, 'allocateProportionally.total');
    if (total < 0)
        throw new errors_1.InvalidAmountError('allocateProportionally : total négatif');
    if (weights.length === 0)
        throw new errors_1.InvalidQuantityError('allocateProportionally : aucun poids');
    if (weights.some((w) => w < 0))
        throw new errors_1.InvalidQuantityError('allocateProportionally : poids négatif');
    const weightSum = weights.reduce((s, w) => s + w, 0);
    if (weightSum === 0)
        throw new errors_1.InvalidQuantityError('allocateProportionally : somme des poids nulle');
    // Tout en entiers : comparer des flottants (r - Math.floor(r)) fait dériver
    // le départage quand deux restes rationnels sont exactement égaux. Le
    // reste exact de chaque part est total*w - floor(total*w/weightSum)*weightSum,
    // un entier tant que total*w reste sous 2^53 (montants en centimes). floor
    // et reste sont calculés ensemble pour ne jamais ré-indexer un tableau par
    // un indice dérivé (noUncheckedIndexedAccess).
    const parts = weights.map((w) => {
        const floor = Math.floor((total * w) / weightSum);
        const remainder = total * w - floor * weightSum;
        return { floor, remainder };
    });
    const floors = parts.map((p) => p.floor);
    let remainder = total - floors.reduce((s, f) => s + f, 0);
    const byRemainder = parts
        .map((p, index) => ({ index, r: p.remainder }))
        .sort((a, b) => b.r - a.r || a.index - b.index);
    const result = [...floors];
    for (const { index } of byRemainder) {
        if (remainder === 0)
            break;
        const current = result[index];
        if (current === undefined) {
            throw new errors_1.InvalidQuantityError('allocateProportionally : indice hors limites (erreur interne)');
        }
        result[index] = current + 1;
        remainder -= 1;
    }
    return result;
}
